import moment from 'moment'

export function date(value) {
  return value ? moment(value).format('DD.MM.YYYY') : ''
}

export function datetime(value) {
  return value ? moment(value).format('DD.MM.YYYY HH:mm') : ''
}



// WEBPACK FOOTER //
// ./resources/js/filters.js